import MessageViewer from "./common/message.js";

export default {
    tags        : [ "Message" ],
    name        : "message_edit",
    viewer      : MessageViewer,

    definition: (i18n, log) => {
        return i18n("logs_definition.message_edit");
    },

    filter: {
        icon: "chat",
        name: (i18n) => "Modification de message",
    },
}
